import { useAuth0 } from '@auth0/auth0-react';
import { logoutUserBI } from '../services/mixpanel';
import { useAuthOrg } from './useAuthOrg';
import { useCallback } from 'react';
import { useAccountSelectionContext } from '../components/account-selection/AccountSelectionContext';

const useLogout = () => {
  const { logout } = useAuth0();
  const { authOrgQueryParam } = useAuthOrg();
  const { isAuthZeroAccessDenied, isSSOUser } = useAccountSelectionContext();

  const logoutFn = useCallback(() => {
    let returnTo = window.location.origin;
    const allowNavigateToOrg = isSSOUser ? true : !isAuthZeroAccessDenied;
    if (authOrgQueryParam && allowNavigateToOrg) {
      returnTo += '?' + authOrgQueryParam;
    }
    logoutUserBI();
    logout({
      logoutParams: { returnTo },
    });
  }, [authOrgQueryParam, logout, isAuthZeroAccessDenied, isSSOUser]);

  return { logout: logoutFn };
};

export default useLogout;
